import {useListView} from '../../core/ListViewProvider'
import {RolesPermissionsListToolbar} from './RolePermissionListToolbar'
import {RolesPermissionsListGrouping} from './RolesPermissionsListGrouping'
import {RolesPermissionsListSearchComponent} from './RolesPermissionsListSearchComponent'

const RolesPermissionsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <RolesPermissionsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <RolesPermissionsListGrouping /> : <RolesPermissionsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {RolesPermissionsListHeader}
